<template>
  <v-autocomplete v-bind="computedProps" v-on="$listeners" outlined clearable>
    <!-- pass through scoped slots -->
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>

    <!-- pass through normal slots -->
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-autocomplete>
</template>

<script>
import { VAutocomplete } from "vuetify/lib";
export default {
  name: "SAutocomplete",
  extends: VAutocomplete,
  props: {
    color: {
      type: String,
      default: "primaryColor",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedProps() {
      return {
        ...this.$props,
        prependIcon: this.icon,
        color: this.color,
      };
    },
  },
};
</script>

<style></style>
